import {Injectable} from '@angular/core';

import {BehaviorSubject} from 'rxjs';
import {DataService} from './data.service';
import {AngularFireMessaging} from "@angular/fire/compat/messaging";

@Injectable()
export class MessagingService {

  currentMessage = new BehaviorSubject(null);
  // audio = new Audio('assets/order_delivered.mp3');
  public audio: HTMLAudioElement;


  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private http: DataService) {

    this.receiveMessage();
    this.audio = new Audio();
    this.audio.src = 'assets/order_delivered.mp3';
    this.angularFireMessaging.messages.subscribe(
      (messaging) => {
        // messaging.onMessage = messaging.onMessage.bind(messaging);
        // messaging.onTokenRefresh = messaging.onTokenRefresh.bind(messaging);
      },
    );

  }

  /**
   * update token in firebase database
   *
   * @param userId userId as a key
   * @param token token as a value
   */
  updateToken(userId, token) {
    // we can change this function to request our backend service
    try {
      // this.http.update(userId, {web_token: token}, {__include: '', __only: ['id']}, 'user', 'auth').then();
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * request permission for notification from firebase cloud messaging
   *
   * @param userId userId
   */
  requestPermission(userId) {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        this.updateToken(userId, token);
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      },
    );
  }

  /**
   * hook method when new notification received in foreground
   */
  receiveMessage() {
    const self = this;
    this.angularFireMessaging.messages.subscribe(
      (payload: any) => {
        // this.audio.load();
        self.audio.play();
        this.currentMessage.next(payload);
      });
  }
}
